




























import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { Action, Getter, State } from 'vuex-class';
import { deploymentSvc } from '@/services';
import { Deployment, Credentials, DeploymentDataLoaderParams } from '@/types';

@Component({
  name: 'upaffiliate-info-dialog',
  components: {}
})
export default class UpaffiliateInfoDialog extends Vue {
  @Prop({ required: true })
  show!: boolean;

  @Prop({ required: true })
  deployment!: Deployment;

  upimportDeployments: Deployment[] = [];
  selectedUpimport: Deployment | null = null;
  upimportLoading: boolean = false;

  mounted() {
    this.fetchUpimports();
  }

  async fetchUpimports() {
    this.upimportLoading = true;
    try {
      const result = await deploymentSvc.getDeployments({
        first: 2147483647,
        page: 1,
        filters: {
          serviceSlug: 'upimport',
          isActive: true
        }
      } as DeploymentDataLoaderParams);
      this.upimportDeployments = result.deployments.data;
    } catch (e) {
      // blank
    }
    this.upimportLoading = false;
  }

  async connectUpimport() {
    this.upimportLoading = true;
    try {
      await deploymentSvc.connectUpimport(
        this.selectedUpimport!.id,
        this.deployment.id
      );
    } catch (e) {
      // blank
    }
    this.upimportLoading = false;
  }

  get upimportDropdownValues() {
    return this.upimportDeployments.map(deployment => ({
      value: deployment.id,
      text: deployment.subdomain
    }));
  }

  get selectedUpimportId() {
    return this.selectedUpimport ? this.selectedUpimport.id : null;
  }

  set selectedUpimportId(id) {
    const found = this.upimportDeployments.find(deployment => {
      return deployment.id === id;
    });
    this.selectedUpimport = found ? found : null;
  }

  closeDialog() {
    this.$emit('close');
  }
}
